import React, {useState} from "react";
import {StaticFieldDisplayProps} from "../staticFieldUtils.ts";
import {FormImageType, ImageSubmission} from "../../../../../api/ApiTypes.ts";
import {ImageDisplay} from "../../image/ImageDisplay.tsx";
import {FullSizeImageModal} from "../../image/FullSizeImageModal.tsx";



const StaticImageRenderer: React.FC<StaticFieldDisplayProps> = ({ value }) => {
    const imageArray = value as ImageSubmission[];
    const frontImage = imageArray?.find((image) => image.imageType === FormImageType.FRONT);
    const [selectedModalImage, setSelectedModalImage] = useState<ImageSubmission | null>(null);

    return (
        <div className="relative w-full aspect-[4/3] bg-gray-200 rounded overflow-hidden border-3 border-gray-200">
            {frontImage !== undefined
                ? <button
                    type="button"
                    key={frontImage.generalFileId}
                    className="relative h-36 w-36 flex-shrink-0 border-gray-400 border-1 bg-gray-600"
                    onClick={() => setSelectedModalImage(frontImage)}
                >
                    <ImageDisplay image={frontImage}/>
                </button>
                : <div className="absolute inset-0 flex items-center justify-center bg-gray-200">
                    <span className="text-gray-500">No images.</span>
                </div>
            }
            <FullSizeImageModal selectedModalImage={selectedModalImage} onClose={() => setSelectedModalImage(null)} />
        </div>
    );
};
export const StaticImage = React.memo(StaticImageRenderer);